import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import AddLeadData from "./components/AddLeadData";

const initialData = {
  bds: "",
  broker: "",
  lead_source: "",
  contact: "",
  lead_type: "",
  link: "",
  contact_name: "",
  created_at: "",
  lead_status: "2",
  suggested_sale_price: "",
  suggested_cap_rate: "",
  portfolio: 0,
  override_reason: ""
};

const EditLeadModal = ({ showModal, onClose, id, from, onCallApi }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
    setDisable(false);
  };

  useEffect(() => {
    if (id && showModal) {
      setLoading(true);

      const url =
        from === "Lead"
          ? `${BASE_URL}/getby-Id/${id}?type=1`
          : `${BASE_URL}/getby-Id/${id}`;

      axios
        .get(url, config)
        .then((res) => {
          const data = res?.data?.LeadsList;

          setFormData({
            bds: data?.bds,
            broker: data?.broker,
            lead_source: data?.lead_source_id,
            created_at: data.created_at,
            contact: data?.contact?.id,
            override_reason: data.override_reason,
            lead_type: data?.lead_type === 1 ? "acquisition" : "disposition",
            link: data?.link?.id,
            suggested_sale_price: data?.suggested_sale_price,
            suggested_cap_rate: data?.suggested_cap_rate,
            lead_status: data?.lead_status,
            contact_name: `${data?.contact?.first_name} ${data?.contact?.last_name}`,
            portfolio: data?.portfolio,
          });
        })
        .catch((err) => {
          if (
            err.response?.data?.message &&
            err.response?.data?.message !== "Too Many Attempts."
          ) {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [id, showModal, from]); // ✅ add from as dependency

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    const dataToSend = {
      bds: formData.bds,
      broker: formData.broker,
      lead_source_id: formData.lead_source,
      contact_id: formData.contact,
      link_id: formData.link,
      override_reason: formData.override_reason,
      suggested_sale_price: formData.suggested_sale_price,
      suggested_cap_rate: formData?.suggested_cap_rate,
      created_at: formData.created_at,
      lead_type: formData?.lead_type === "acquisition" ? 1 : 0,
      type: from === "Lead" ? 0 : 1,
      lead_status: "2",
      portfolio: formData?.portfolio ?? 0,
    };
      axios
      .put(`${BASE_URL}/update-lead/${id}`, dataToSend, config)
      .then((res) => {
        NotificationManager.success(res?.data?.message || "Lead updated successfully");
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setDisable(false);
        setError(err.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  return (
    <Modal title={`Edit ${from}`} desc={`Edit the ${from} information.`} show={showModal} onClose={handleClose}>
      {loading ? (
        <Loader />
      ) : (
        <AddLeadData
          formData={formData}
          error={error}
          onSetFormData={(value) => {
            setFormData(value);
          }}
          onSetError={(value) => setError(value)}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
          showModal={showModal}
          from={from}
        />
      )}
    </Modal>
  );
};

export default EditLeadModal;
